module.exports = __webpack_public_path__ + "img/music1.d1218434.png";